var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.hasInformationsGeneralesData ? _c('div', [_c('h3', {
    staticClass: "xl:mt-15 xl:mb-15 w-full"
  }, [_vm._v("Personnes")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-2 gap-x-5 justify-between"
  }, [_c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('div', [_c('doughnut', {
    attrs: {
      "id-chart": "gender",
      "title": "Genre",
      "labels": _vm.gender.longLabels,
      "values": _vm.gender.datas,
      "thickness": "70",
      "colors": [_vm.color('pink'), _vm.color('indigo')],
      "position-legend": "bottom",
      "height": "400",
      "width": "400"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [false && _vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('div', [_c('bar', {
    attrs: {
      "id-chart": "age",
      "title": "ages",
      "orientation": "horizontal",
      "labels": _vm.age.longLabels,
      "values": _vm.age.datas,
      "thickness": 10,
      "height": "400",
      "width": "400",
      "stacked": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('h3', {
    staticClass: "xl:mt-15 xl:mb-10 w-full"
  }, [_vm._v("Informations générales")]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex flex-col space-y-2 items-center mb-10"
  }, [_c('div', [_c('doughnut', {
    staticClass: "w-50",
    attrs: {
      "id-chart": "handicap",
      "title": "Handicap",
      "labels": _vm.handicap.longLabels,
      "values": _vm.handicap.datas,
      "thickness": "70",
      "colors": _vm.color('tenColors'),
      "position-legend": "right",
      "height": "375",
      "width": "700"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-2 gap-x-5 gap-y-10 justify-between"
  }, [_c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('div', [_c('bar', {
    attrs: {
      "id-chart": "formations",
      "title": "Formations",
      "orientation": "vertical",
      "labels": _vm.formations.longLabels,
      "values": _vm.formations.datas,
      "thickness": 10,
      "height": "400",
      "width": "400",
      "stacked": false,
      "display-xaxis": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-8 flex justify-center"
  }, [_vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "xl:ml-5 mt-5"
  }, _vm._l(_vm.formations.longLabels, function (lib, n) {
    return _c('div', {
      key: n,
      staticClass: "flex space-x-1 items-center"
    }, [_c('div', {
      staticClass: "h-2 w-2 rounded-full",
      style: 'backgroundColor: ' + _vm.color('nineColors')[n]
    }), _vm._v(" "), _c('p', {
      staticClass: "text-2sm text-gray-600"
    }, [_vm._v("\n            " + _vm._s(lib) + "\n          ")])]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('div', [_c('bar', {
    attrs: {
      "id-chart": "situationanterieure",
      "title": "Situation antérieure",
      "orientation": "vertical",
      "labels": _vm.situationAnterieure.longLabels,
      "values": _vm.situationAnterieure.datas,
      "thickness": 10,
      "height": "400",
      "width": "400",
      "stacked": false,
      "display-xaxis": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "xl:ml-10 mt-5"
  }, _vm._l(_vm.situationAnterieure.longLabels, function (lib, n) {
    return _c('div', {
      key: n,
      staticClass: "flex space-x-1 items-center"
    }, [_c('div', {
      staticClass: "h-2 w-2 rounded-full",
      style: 'backgroundColor: ' + _vm.color('fourteenColors')[n]
    }), _vm._v(" "), _c('p', {
      staticClass: "text-2sm text-gray-600"
    }, [_vm._v("\n            " + _vm._s(lib) + "\n          ")])]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('div', [_c('doughnut', {
    attrs: {
      "id-chart": "tempsTravail",
      "title": "Temps de travail",
      "labels": _vm.tempsTravail.longLabels,
      "values": _vm.tempsTravail.datas,
      "thickness": "70",
      "colors": [_vm.color('pink'), _vm.color('indigo')],
      "position-legend": "bottom",
      "height": "400",
      "width": "400"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('div', [_c('doughnut', {
    attrs: {
      "id-chart": "contrats",
      "title": "Contrats",
      "labels": _vm.contrats.shortLabels,
      "values": _vm.contrats.datas,
      "thickness": "70",
      "colors": _vm.color('tenColors'),
      "position-legend": "bottom",
      "height": "400",
      "width": "400"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('h5', {
    staticClass: "text-indigo-600 font-bold mb-10"
  }, [_vm._v("REMUNERATION")]), _vm._v(" "), _c('div', {
    staticClass: "border-dashed border-gray-600 rounded-2xl border-2 p-5"
  }, [_c('div', {
    staticClass: "border-dashed border-gray-600 border-b-2 pb-5"
  }, [_c('span', {
    staticClass: "inline-block border-2 rounded-full border-indigo-600 p-1.5 -mb-2 mr-2"
  }, [_c('icon', {
    staticClass: "text-indigo-600",
    attrs: {
      "name": "collapse"
    }
  })], 1), _vm._v("\n          " + _vm._s(_vm.remuneration.moyenne) + "€ rémunération moyenne brute\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "border-dashed border-gray-600 border-b-2 pb-5 pt-5"
  }, [_c('span', {
    staticClass: "inline-block border-2 rounded-full border-pink-600 py-1 px-1.5 -mb-2 mr-2"
  }, [_c('icon', {
    staticClass: "text-pink-600",
    attrs: {
      "name": "arrow-up"
    }
  })], 1), _vm._v("\n          " + _vm._s(_vm.remuneration.max) + "€ rémunération brute la plus haute\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pt-5"
  }, [_c('span', {
    staticClass: "inline-block border-2 rounded-full border-pink-600 py-1 px-1.5 -mb-2 mr-2"
  }, [_c('icon', {
    staticClass: "text-pink-600",
    attrs: {
      "name": "arrow-down"
    }
  })], 1), _vm._v("\n          " + _vm._s(_vm.remuneration.min) + "€ rémunération brute la plus basse\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('div', [_c('doughnut', {
    attrs: {
      "id-chart": "hebergement",
      "title": "Hébergement",
      "labels": _vm.hebergement.shortLabels,
      "values": _vm.hebergement.datas,
      "thickness": "70",
      "colors": _vm.color('eightColors'),
      "position-legend": "bottom",
      "height": "400",
      "width": "400"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('div', [_c('bar', {
    attrs: {
      "id-chart": "mobilite",
      "title": "Mobilité",
      "orientation": "vertical",
      "labels": _vm.mobilite.longLabels,
      "values": _vm.mobilite.datas,
      "thickness": 10,
      "height": "400",
      "width": "400",
      "stacked": false,
      "display-xaxis": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "xl:ml-10 mt-5"
  }, _vm._l(_vm.mobilite.longLabels, function (lib, n) {
    return _c('div', {
      key: n,
      staticClass: "flex space-x-1 items-center"
    }, [_c('div', {
      staticClass: "h-2 w-2 rounded-full",
      style: 'backgroundColor: ' + _vm.color('elevenColors')[n]
    }), _vm._v(" "), _c('p', {
      staticClass: "text-2sm text-gray-600"
    }, [_vm._v("\n            " + _vm._s(lib) + "\n          ")])]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('div', [_c('bar', {
    attrs: {
      "id-chart": "reconnaissance",
      "title": "Type de reconnaissance",
      "orientation": "vertical",
      "labels": _vm.reconnaissance.longLabels,
      "values": _vm.reconnaissance.datas,
      "thickness": 10,
      "height": "400",
      "width": "400",
      "stacked": false,
      "display-xaxis": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "xl:ml-10 mt-5"
  }, _vm._l(_vm.reconnaissance.longLabels, function (lib, n) {
    return _c('div', {
      key: n,
      staticClass: "flex space-x-1 items-center"
    }, [_c('div', {
      staticClass: "h-2 w-2 rounded-full",
      style: 'backgroundColor: ' + _vm.color('nineColors')[n]
    }), _vm._v(" "), _c('p', {
      staticClass: "text-2sm text-gray-600"
    }, [_vm._v("\n            " + _vm._s(lib) + "\n          ")])]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('div', [_c('bar', {
    attrs: {
      "id-chart": "statut",
      "title": "Statut",
      "orientation": "vertical",
      "labels": _vm.statut.longLabels,
      "values": _vm.statut.datas,
      "thickness": 10,
      "height": "400",
      "width": "400",
      "stacked": false,
      "display-xaxis": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "xl:ml-10 mt-5"
  }, _vm._l(_vm.statut.longLabels, function (lib, n) {
    return _c('div', {
      key: n,
      staticClass: "flex space-x-1 items-center"
    }, [_c('div', {
      staticClass: "h-2 w-2 rounded-full",
      style: 'backgroundColor: ' + _vm.color('eightColors')[n]
    }), _vm._v(" "), _c('p', {
      staticClass: "text-2sm text-gray-600"
    }, [_vm._v("\n            " + _vm._s(lib) + "\n          ")])]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full xl:col-span-1 flex flex-col space-y-2"
  }, [_c('div', [_c('bar', {
    attrs: {
      "id-chart": "qualification",
      "title": "Qualification",
      "orientation": "vertical",
      "labels": _vm.qualification.longLabels,
      "values": _vm.qualification.datas,
      "thickness": 10,
      "height": "400",
      "width": "400",
      "stacked": false,
      "display-xaxis": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_vm.$can('cartography_collective_save') ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "libelle": "Enregistrer"
    }
  }) : _vm._e(), _vm._v(" "), false && _vm.$can(_vm.constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE) ? _c('action-button', {
    staticClass: "py-2",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-600",
      "bg-color": "bg-gray-300",
      "libelle": "Comparer"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "xl:ml-10 mt-5"
  }, _vm._l(_vm.qualification.longLabels, function (lib, n) {
    return _c('div', {
      key: n,
      staticClass: "flex space-x-1 items-center"
    }, [_c('div', {
      staticClass: "h-2 w-2 rounded-full",
      style: 'backgroundColor: ' + _vm.color('nineColors')[n]
    }), _vm._v(" "), _c('p', {
      staticClass: "text-2sm text-gray-600"
    }, [_vm._v("\n            " + _vm._s(lib) + "\n          ")])]);
  }), 0)])])]) : _c('div', {
    staticClass: "text-center mt-1/10 text-gray-600"
  }, [_vm._v("\n  Aucune donnée à afficher.\n")]);

}
var staticRenderFns = []

export { render, staticRenderFns }